// extracted by mini-css-extract-plugin
module.exports = {"inputPhoneNumber":"_3vrRyi6sBWxzWfqJZmjkk5","code":"fDE3HqpxLDNfhUibd2BLB","number":"_1pc6Zy9T4y-TQrjwnUDpdG"};